import CookieConsent from 'react-cookie-consent';

import { Typography } from '../../utils/material-ui-core';

const CookieConsentConfirmationButton = () => {
  return (
    <CookieConsent
      cookieName="SensorAdminCookieConsentConfirmation"
      buttonText="I ACCEPT"
      expires={999}
      overlay
      buttonStyle={{
        background: "#ff7832",
        color: "#ffffff",
      }}
    >
      <Typography variant="h6">This website uses cookies</Typography>
      <Typography variant="body1">We use cookies to improve user experience. Choose what cookies you allow us to use. You can read more about our Cookie Policy in our Privacy policy</Typography>
    </CookieConsent>
  );
};

export default CookieConsentConfirmationButton;
